var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureDevops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2588DF;}\n\t.st1{fill:#559CEC;}\n\t.st2{fill:#569DEC;}\n\t.st3{fill:#579DED;}\n\t.st4{fill:#589EED;}\n\t.st5{fill:#5A9EEE;}\n\t.st6{fill:#5B9FEE;}\n\t.st7{fill:#5C9FEE;}\n\t.st8{fill:#5DA0EF;}\n\t.st9{fill:#5EA0EF;}\n\t.st10{fill:#0078D4;}\n\t.st11{fill:#0178D4;}\n\t.st12{fill:#0279D5;}\n\t.st13{fill:#0379D5;}\n\t.st14{fill:#047AD5;}\n\t.st15{fill:#057AD6;}\n\t.st16{fill:#067BD6;}\n\t.st17{fill:#077BD6;}\n\t.st18{fill:#087CD7;}\n\t.st19{fill:#0A7CD7;}\n\t.st20{fill:#0B7CD7;}\n\t.st21{fill:#0C7DD8;}\n\t.st22{fill:#0D7DD8;}\n\t.st23{fill:#0E7ED8;}\n\t.st24{fill:#0F7ED9;}\n\t.st25{fill:#107FD9;}\n\t.st26{fill:#117FD9;}\n\t.st27{fill:#1280DA;}\n\t.st28{fill:#1380DA;}\n\t.st29{fill:#1480DA;}\n\t.st30{fill:#1581DB;}\n\t.st31{fill:#1681DB;}\n\t.st32{fill:#1782DB;}\n\t.st33{fill:#1882DB;}\n\t.st34{fill:#1983DC;}\n\t.st35{fill:#1A83DC;}\n\t.st36{fill:#1B83DC;}\n\t.st37{fill:#1C84DC;}\n\t.st38{fill:#1D84DD;}\n\t.st39{fill:#1E85DD;}\n\t.st40{fill:#1F85DD;}\n\t.st41{fill:#2086DE;}\n\t.st42{fill:#2186DE;}\n\t.st43{fill:#2286DE;}\n\t.st44{fill:#2387DE;}\n\t.st45{fill:#2487DF;}\n\t.st46{fill:#2688DF;}\n\t.st47{fill:#2889E0;}\n\t.st48{fill:#2989E0;}\n\t.st49{fill:#2A89E0;}\n\t.st50{fill:#2B8AE0;}\n\t.st51{fill:#2C8AE1;}\n\t.st52{fill:#2D8BE1;}\n\t.st53{fill:#2E8BE1;}\n\t.st54{fill:#2F8BE1;}\n\t.st55{fill:#308CE2;}\n\t.st56{fill:#318CE2;}\n\t.st57{fill:#328DE2;}\n\t.st58{fill:#338DE3;}\n\t.st59{fill:#348EE3;}\n\t.st60{fill:#358EE3;}\n\t.st61{fill:#368EE3;}\n\t.st62{fill:#378FE4;}\n\t.st63{fill:#388FE4;}\n\t.st64{fill:#3990E4;}\n\t.st65{fill:#3A90E4;}\n\t.st66{fill:#3B91E5;}\n\t.st67{fill:#3C91E5;}\n\t.st68{fill:#3D91E5;}\n\t.st69{fill:#3E92E6;}\n\t.st70{fill:#3F92E6;}\n\t.st71{fill:#4093E6;}\n\t.st72{fill:#4193E6;}\n\t.st73{fill:#4294E7;}\n\t.st74{fill:#4394E7;}\n\t.st75{fill:#4495E7;}\n\t.st76{fill:#4595E8;}\n\t.st77{fill:#4696E8;}\n\t.st78{fill:#4796E8;}\n\t.st79{fill:#4997E9;}\n\t.st80{fill:#4A97E9;}\n\t.st81{fill:#4B97E9;}\n\t.st82{fill:#4C98E9;}\n\t.st83{fill:#4D98EA;}\n\t.st84{fill:#4E99EA;}\n\t.st85{fill:#4F99EA;}\n\t.st86{fill:#509AEB;}\n\t.st87{fill:#519AEB;}\n\t.st88{fill:#529BEB;}\n\t.st89{fill:#539BEB;}\n\t.st90{fill:#549CEC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.1,52.5 19.1,31.1 56.4,23.6 56.4,55.3 19.2,52.5 32,69 32,60.9 54.5,69.1 69.1,57.2 69.1,21.8  56.5,23.5 35.8,10.9 35.8,19.2 16.7,24.9 10.9,32.2 10.9,49  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.7,21.1 29.3,21.1 27,21.8 53.8,21.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "50.7,20 33.3,20 29.3,21.1 52.7,21.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "48.8,18.8 35.8,18.8 35.8,19.2 33.3,20 50.7,20  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "46.9,17.7 35.8,17.7 35.8,18.8 48.8,18.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45,16.5 35.8,16.5 35.8,17.7 46.9,17.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "43.1,15.3 35.8,15.3 35.8,16.5 45,16.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "41.2,14.2 35.8,14.2 35.8,15.3 43.1,15.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "39.3,13 35.8,13 35.8,14.2 41.2,14.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "37.4,11.9 35.8,11.9 35.8,13 39.3,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "35.8,10.9 35.8,11.9 37.4,11.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "54.5,69.1 54.8,68.9 54,68.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "32,69 32,68.9 31.9,68.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "31.9,68.9 32,68.9 32,68.4 31.5,68.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "54,68.9 54.8,68.9 55.4,68.4 52.7,68.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "52.7,68.4 55.4,68.4 56,67.9 51.4,67.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "31.5,68.4 32,68.4 32,67.9 31.2,67.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "51.4,67.9 56,67.9 56.6,67.4 50,67.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "31.2,67.9 32,67.9 32,67.4 30.8,67.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "30.8,67.4 32,67.4 32,67 30.4,67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "50,67.4 56.6,67.4 57.2,67 48.7,67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "48.7,67 57.2,67 57.7,66.5 47.3,66.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "30.4,67 32,67 32,66.5 30,66.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "47.3,66.5 57.7,66.5 58.3,66 46,66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "30,66.5 32,66.5 32,66 29.6,66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "46,66 58.3,66 58.9,65.5 44.7,65.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "29.6,66 32,66 32,65.5 29.3,65.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "44.7,65.5 58.9,65.5 59.5,65 43.3,65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "29.3,65.5 32,65.5 32,65 28.9,65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "28.9,65 32,65 32,64.5 28.5,64.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "43.3,65 59.5,65 60.1,64.5 42,64.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "28.5,64.5 32,64.5 32,64 28.1,64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "42,64.5 60.1,64.5 60.7,64 40.7,64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "28.1,64 32,64 32,63.5 27.7,63.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "40.7,64 60.7,64 61.3,63.5 39.3,63.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "39.3,63.5 61.3,63.5 61.9,63.1 38,63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "27.7,63.5 32,63.5 32,63.1 27.4,63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "38,63.1 61.9,63.1 62.5,62.6 36.6,62.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "27.4,63.1 32,63.1 32,62.6 27,62.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "36.6,62.6 62.5,62.6 63.1,62.1 35.3,62.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "27,62.6 32,62.6 32,62.1 26.6,62.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "26.6,62.1 32,62.1 32,61.6 26.2,61.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "35.3,62.1 63.1,62.1 63.7,61.6 34,61.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "26.2,61.6 32,61.6 32,61.1 25.9,61.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "34,61.6 63.7,61.6 64.3,61.1 32.6,61.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "25.9,61.1 32,61.1 32,60.9 32.6,61.1 64.3,61.1 64.9,60.6 25.5,60.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "25.5,60.6 64.9,60.6 65.5,60.1 25.1,60.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "25.1,60.1 65.5,60.1 66.1,59.6 24.7,59.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "24.7,59.6 66.1,59.6 66.7,59.1 24.3,59.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "24.3,59.1 66.7,59.1 67.4,58.6 23.9,58.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "23.9,58.6 67.4,58.6 68,58.1 23.5,58.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "23.5,58.1 68,58.1 68.6,57.6 23.1,57.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "23.1,57.6 68.6,57.6 69.1,57.2 69.1,57 22.7,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "22.7,57 69.1,57 69.1,56.5 22.3,56.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "22.3,56.5 69.1,56.5 69.1,56 21.9,56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "21.9,56 69.1,56 69.1,55.5 21.5,55.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "56.4,55.3 52.2,54.9 21.1,54.9 21.5,55.5 69.1,55.5 69.1,54.9 56.4,54.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "45.1,54.4 20.7,54.4 21.1,54.9 52.2,54.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 54.4,
    className: "st37",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "37.9,53.9 20.3,53.9 20.7,54.4 45.1,54.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 53.9,
    className: "st38",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 53.4,
    className: "st39",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "30.8,53.4 19.8,53.4 20.3,53.9 37.9,53.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "23.7,52.9 19.4,52.9 19.8,53.4 30.8,53.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 52.9,
    className: "st40",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "19.2,52.5 19.4,52.9 23.7,52.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 52.3,
    className: "st41",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "19.1,52.5 19.1,52.3 18.7,52.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 51.8,
    className: "st42",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "18.7,52.3 19.1,52.3 19.1,51.8 17.5,51.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "17.5,51.8 19.1,51.8 19.1,51.3 16.3,51.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 51.3,
    className: "st43",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "16.3,51.3 19.1,51.3 19.1,50.8 15.1,50.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 50.8,
    className: "st44",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "15.1,50.8 19.1,50.8 19.1,50.2 13.9,50.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 50.2,
    className: "st45",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "13.9,50.2 19.1,50.2 19.1,49.7 12.6,49.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 49.7,
    className: "st0",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "12.6,49.7 19.1,49.7 19.1,49.2 11.4,49.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 49.2,
    className: "st46",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 48.7,
    className: "st47",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "10.9,49 11.4,49.2 19.1,49.2 19.1,48.7 10.9,48.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 48.2,
    className: "st48",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 48.2,
    className: "st48",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 47.6,
    className: "st49",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 47.6,
    className: "st49",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 47.1,
    className: "st50",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 47.1,
    className: "st50",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 46.6,
    className: "st51",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 46.6,
    className: "st51",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 46.1,
    className: "st52",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 46.1,
    className: "st52",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 45.5,
    className: "st53",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 45.5,
    className: "st53",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 45,
    className: "st54",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 45,
    className: "st54",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 44.5,
    className: "st55",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 44.5,
    className: "st55",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 44,
    className: "st56",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 44,
    className: "st56",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 43.5,
    className: "st57",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 43.5,
    className: "st57",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 42.9,
    className: "st58",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 42.9,
    className: "st58",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 42.4,
    className: "st59",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 42.4,
    className: "st59",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 41.9,
    className: "st60",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 41.9,
    className: "st60",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 41.4,
    className: "st61",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 41.4,
    className: "st61",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 40.8,
    className: "st62",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 40.8,
    className: "st62",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 40.3,
    className: "st63",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 40.3,
    className: "st63",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 39.8,
    className: "st64",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 39.8,
    className: "st64",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 39.3,
    className: "st65",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 39.3,
    className: "st65",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 38.7,
    className: "st66",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 38.7,
    className: "st66",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 38.2,
    className: "st67",
    width: 8.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 38.2,
    className: "st67",
    width: 12.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 37.6,
    className: "st67",
    width: 8.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 37.6,
    className: "st67",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 36.9,
    className: "st68",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 36.9,
    className: "st68",
    width: 8.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 36.2,
    className: "st69",
    width: 8.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 36.2,
    className: "st69",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 35.5,
    className: "st70",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 35.5,
    className: "st70",
    width: 8.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 34.9,
    className: "st71",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 34.9,
    className: "st71",
    width: 8.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 34.2,
    className: "st72",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 34.2,
    className: "st72",
    width: 8.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 33.5,
    className: "st73",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 33.5,
    className: "st73",
    width: 8.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 32.9,
    className: "st74",
    width: 8.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 32.9,
    className: "st74",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "10.9,32.2 10.9,32.9 19.1,32.9 19.1,32.2 10.9,32.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 32.2,
    className: "st75",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 31.5,
    className: "st76",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "10.9,32.2 19.1,32.2 19.1,31.5 11.5,31.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 30.8,
    className: "st77",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "11.5,31.5 19.1,31.5 19.1,31.1 20.6,30.8 12,30.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 30.2,
    className: "st78",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "12,30.8 20.6,30.8 24,30.2 12.5,30.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "12.5,30.2 24,30.2 27.3,29.5 13,29.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 29.5,
    className: "st79",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 28.8,
    className: "st80",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "13,29.5 27.3,29.5 30.7,28.8 13.6,28.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 28.2,
    className: "st81",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "13.6,28.8 30.7,28.8 34,28.2 14.1,28.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 27.5,
    className: "st82",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "14.1,28.2 34,28.2 37.3,27.5 14.6,27.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 26.8,
    className: "st83",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "14.6,27.5 37.3,27.5 40.7,26.8 15.1,26.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "15.1,26.8 40.7,26.8 44,26.1 15.7,26.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 26.1,
    className: "st84",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 25.5,
    className: "st85",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "15.7,26.1 44,26.1 47.4,25.5 16.2,25.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 24.8,
    className: "st86",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "16.7,24.9 16.2,25.5 47.4,25.5 50.7,24.8 16.9,24.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 24.1,
    className: "st87",
    width: 12.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "16.9,24.8 50.7,24.8 54,24.1 19.1,24.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "21.4,23.5 19.1,24.1 54,24.1 56.4,23.6 56.4,24.1 69.1,24.1 69.1,23.5 56.5,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "55.4,22.8 23.7,22.8 21.4,23.5 56.5,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "56.5,23.5 69.1,23.5 69.1,22.8 61.6,22.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "61.6,22.8 69.1,22.8 69.1,22.1 66.8,22.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "54.3,22.1 26,22.1 23.7,22.8 55.4,22.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "69.1,22.1 69.1,21.8 66.8,22.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.8,21.8 27,21.8 26,22.1 54.3,22.1  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDevops);
export default __webpack_public_path__ + "static/media/azure-devops.78426e3622930b8669df76ba4477cd58.svg";
export { ForwardRef as ReactComponent };